import { render, staticRenderFns } from "./VisitStatisticsDeptMg.vue?vue&type=template&id=1b113ff1&scoped=true"
import script from "./VisitStatisticsDeptMg.vue?vue&type=script&lang=js"
export * from "./VisitStatisticsDeptMg.vue?vue&type=script&lang=js"
import style0 from "./VisitStatisticsDeptMg.vue?vue&type=style&index=0&id=1b113ff1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b113ff1",
  null
  
)

export default component.exports